import React from "react";
import { IMAGES } from "../../mock";

const Header = () => {
  return (
    <header
      className="w-full"
      style={{
        background: "linear-gradient(180deg, var(--me-header-from) 0%, var(--me-header-to) 100%)",
      }}
    >
      <div className="max-w-[1200px] mx-auto px-6 py-6 md:py-8 flex justify-center">
        <img
          src={IMAGES.logo}
          alt="Meilleurelec.fr - comparateur d'offres d'électricité"
          width={468}
          height={120}
          loading="eager"
          fetchPriority="high"
          className="h-9 md:h-11 w-auto object-contain select-none"
          draggable={false}
        />
      </div>
    </header>
  );
};

export default Header;
